import { createFeature, createReducer, on } from '@ngrx/store';
import { StudentProfile } from '../../../core/services/student-portal.service';
import { ApplicantFieldsFormValue } from '../models/applicant-fields.model';
import { ApplicantFieldsActions } from './applicant-fields.actions';

export interface ApplicantFieldsState {
  loading: boolean;
  profile: StudentProfile | null;
  savedFields: Partial<ApplicantFieldsFormValue>;
}

const initialState: ApplicantFieldsState = {
  loading: false,
  profile: null,
  savedFields: {},
};

export const applicantFieldsFeature = createFeature({
  name: 'applicantFields',
  reducer: createReducer(
    initialState,
    on(ApplicantFieldsActions.loadPageData, (state) => ({ ...state, loading: true })),
    on(ApplicantFieldsActions.loadPageDataSuccess, (state, { profile, savedFields }) => ({
      ...state,
      profile,
      savedFields,
      loading: false,
    })),
    on(ApplicantFieldsActions.loadPageDataFailure, (state, { savedFields }) => ({
      ...state,
      savedFields,
      loading: false,
    })),
    on(ApplicantFieldsActions.saveFieldsSuccess, (state, { value }) => ({
      ...state,
      savedFields: value,
    })),
  ),
});
